module.exports = __webpack_public_path__ + "media/reskin-images/icon--h2h-phone-30af8e07.svg";